export default __webpack_public_path__ + "static/1-daba7b0e79d465ab75bf9a099c51d985.png";